type SectionProps = {
	children: React.ReactNode
	sectionId: string
	backgroundColor?: string // Optional background color prop
	backgroundImage?: string // Optional background image prop
	gradientBackground?: string // Optional gradient background prop
}

function Section({
	children,
	sectionId,
	backgroundColor,
	backgroundImage,
	gradientBackground,
}: SectionProps) {
	return (
		<section
			id={sectionId}
			className="relative bg-fixed bg-cover bg-center"
			style={{
				backgroundColor:
					!gradientBackground && backgroundColor
						? backgroundColor
						: 'transparent',
				backgroundImage: gradientBackground
					? gradientBackground
					: backgroundImage
					? `url(${backgroundImage})`
					: undefined,
			}}
		>
			{/* Blur Overlay */}
			<div className="absolute inset-0 bg-black bg-opacity-20 backdrop-blur-sm"></div>
			<div className="max-w-[95%] sm:max-w-[90%] lg:max-w-[80%] mx-auto flex justify-center py-8 sm:py-12 z-10 relative">
				{children}
			</div>{' '}
			{/* Center content with responsive width */}
		</section>
	)
}

export default Section
